module.exports = __webpack_public_path__ + "img/150.68062ef4.jpg";